// src/components/InputArea.tsx
import { useRef, memo } from "react";
import TextareaAutosize from 'react-textarea-autosize';

interface InputAreaProps {
  input: string;
  isStreaming: boolean;
  isExpanded: boolean;
  placeholder: string;
  onInputChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export const InputArea = memo(function InputArea({
  input,
  isStreaming,
  isExpanded,
  placeholder,
  onInputChange,
  onKeyDown
}: InputAreaProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div className="flex-1 relative">
      <TextareaAutosize
        ref={textareaRef}
        className="w-full resize-none min-h-[40px] text-base rounded-md border-input bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        placeholder={placeholder}
        value={input}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={isStreaming}
        style={{ fontSize: '16px' }}
        minRows={isExpanded ? 3 : 1}
        maxRows={isExpanded ? 8 : 3}
      />
      
      {/* Small character count indicator */}
      {input.length > 0 && (
        <div className="absolute bottom-1 right-2 text-[10px] text-gray-400 pointer-events-none">
          {input.length}
        </div>
      )}
    </div>
  );
});